import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class authGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate() {
        if (localStorage.getItem('authToken')) {
            return true;
        } else {
            this.router.navigate(['/auth']);
            return false;
        }
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/MileTrack-Frontend-AWS-S3/src/app/core/guards/auth.guard.ts